import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M16 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM9.05 9c-.122 0-.24.05-.325.138A9.966 9.966 0 0 0 6 16a9.966 9.966 0 0 0 2.725 6.862.45.45 0 0 0 .326.138c.43 0 .642-.566.349-.882A8.968 8.968 0 0 1 7 16c0-2.363.91-4.513 2.4-6.118.293-.316.082-.882-.35-.882Zm13.9 0c-.432 0-.643.566-.35.882A8.968 8.968 0 0 1 25 16c0 2.363-.91 4.513-2.4 6.118-.293.316-.082.882.35.882.122 0 .24-.05.325-.138A9.966 9.966 0 0 0 26 16a9.965 9.965 0 0 0-2.725-6.862.446.446 0 0 0-.326-.138Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M5.494 7a.46.46 0 0 0-.357.168A13.942 13.942 0 0 0 2 16c0 3.349 1.176 6.422 3.137 8.832a.46.46 0 0 0 .357.168c.413 0 .632-.503.373-.824A12.966 12.966 0 0 1 2.98 16c0-3.097 1.081-5.941 2.887-8.176.26-.321.04-.824-.373-.824Zm21.012 0c-.413 0-.632.503-.373.824A12.966 12.966 0 0 1 29.02 16c0 3.097-1.081 5.941-2.887 8.176-.26.321-.04.824.373.824a.46.46 0 0 0 .357-.168A13.942 13.942 0 0 0 30 16c0-3.348-1.176-6.423-3.137-8.832A.46.46 0 0 0 26.506 7Z",
      clipRule: "evenodd"
    }
  )
);
var SvgLivefeedOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var LivefeedOutlined_default = SvgLivefeedOutlined;

export { LivefeedOutlined_default as default };
